import { useState, useEffect } from 'react'

export function useVimeoThumbnail(videoId: string) {
  const [thumbnailUrl, setThumbnailUrl] = useState<string | null>(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const controller = new AbortController()

    fetch(
      `https://vimeo.com/api/oembed.json?url=https://vimeo.com/${videoId}`,
      { signal: controller.signal }
    )
      .then((res) => res.json())
      .then((data) => {
        const url = data.thumbnail_url?.replace(/_\d+x\d+/, '_1280x720')
        setThumbnailUrl(url ?? null)
        setIsLoading(false)
      })
      .catch((err) => {
        if (err.name !== 'AbortError') {
          setIsLoading(false)
        }
      })

    return () => controller.abort()
  }, [videoId])

  return { thumbnailUrl, isLoading }
}
